import React from 'react';
import BaseModal from '../baseModal';

//Import Style
import './style.scss';

const ConfirmDefaultModal = ({ show, setShow, action, close }) => {
    return (
        <BaseModal show={show} setShow={setShow} handleClose={close}>
            <p id="transaction-id" className="broadcast-modal-tx" style={{ paddingBottom: '1rem' }}>Do you want to default settings?</p>
            <div id="view-tx-btn" className="broadcast-modal-tx__buttons">
                <button className="button" onClick={action}>Confirm</button>
                <button className="button" onClick={close}>Cancel</button>
            </div>
        </BaseModal>
    )
}

export default ConfirmDefaultModal;